<template>
    <div>
        <div class="header">
            <img :src="topTitle" class="topImg">
            <div class="titles">
                <span class="title">乐庭</span>
            </div>
        </div>
        <div  class="map-container" ref="container">
            <div class="content" :style="conHeight">
                <div class="contents">
                    <div style="width:100%;height:90vh" ref="sctterMap"></div>
                    <div class="mapChoose">
                    <span v-for="(item,index) in parentInfo" :key="item.code">
                        <span class="title" @click="chooseArea(item,index)">{{item.cityName=='全国'?'中国':item.cityName}}</span>
                        <span class="icon" v-show="index+1!=parentInfo.length">></span>
                    </span>
                    </div>
                    <div class="contentsTable">
                      <div class="table">
                        <div class="leftBox">
                          <img :src="leftBox">
                          <div class="leftBoxInfo">
                            <div class="title">
                              <span>养老机构展示</span><img :src="titleImg">
                            </div>
                            <div style="margin-top:40px;padding:0 4% 0 5%">
                              <template>
                                <el-table
                                    :data="tableData1"
                                    @row-click = "currentChange"
                                    stripe
                                    style="width: 100%" height="70vh">
                                    <el-table-column align='center' prop="address" label="地点"></el-table-column>
                                    <el-table-column align='center' prop="name" label="名称"></el-table-column>
                                </el-table>
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mapDialog">
          <el-dialog :visible.sync="dialogTableVisible" top="18vh" width='450px' :modal='false' @closed='closeChild'>
<!--            <div class="modal">
              <img class="backgroundImg" :src="modal">
              <div class="cont">
                <div class="head">
                  <img v-show="dataInfo2[0].logo" :src="institutionImgUrl+dataInfo2[0].logo">
                  <div>
                    <div><span style="font-size:26px;font-weight: bold;">{{dataInfo2[0].name}}</span> <span>{{dataInfo2[0].tel}}</span></div>
                    <div><span>地址：{{dataInfo2[0].address}}</span></div>
                  </div>
                </div>
                <div><span>{{dataInfo2[0].description}}</span></div>
              </div>
            </div>-->
            <div class="modal">
              <img class="backgroundImg" :src="modal">
              <div class="cont">
                <div class="head">
                  <img v-show="dialogData.logo" :src="institutionImgUrl+dialogData.logo">
                  <div>
                    <div><span style="font-size:26px;font-weight: bold;">{{dialogData.name}}</span></div>
                    <div><span>地址：{{dialogData.address}}</span></div>
<!--                    <div><span>经纬度：{{this.}}</span></div>-->
                  </div>
                </div>
                <div style="color: white"><span>{{dialogData.description}}</span></div>
              </div>
            </div>
          </el-dialog>
        </div>
      <div v-show="false">
        <baidu-map @ready="handler"></baidu-map>
      </div>
    </div>
</template>

<script>
// import {timefilters} from "@/common/times";
// import kuang from "./childOneImg/kuang.png"
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getToken} from "@/utils/auth";

export default {
  name: "Home",
  data() {
    return {
      dialogData: {},
      dialogTableVisible:false,
      topTitle:require('../WisdomCloud/img/topTitle.png'),
      topTime:require('../WisdomCloud/img/time.png'),
      leftBox:require('./mapImg/tableBack.png'),
      titleImg:require('./mapImg/title.png'),
      modal:require('./mapImg/modalTitle.png'),
      institutionImgUrl: this.$institutionImgUrl,
      // list: ['安徽省','合肥市','蜀山区','湖南省','衡阳市','雁峰区'],
      Citys: ['安徽省','合肥市','蜀山区','湖南省','衡阳市','雁峰区','浙江省'],
      dataInfo:{
        heardImg:'',
        name:'',
        gender:'',
        birthday:'',
        isMarriage:'',
      },
      dataInfo2: [],
      conHeight: {
        height: ''
      },
      valueDate:'',
      myCharts: null,
        geoJson: {
          features: []
        },
        parentInfo: [{
          cityName: "全国",
          code: 100000
        }],
      tableData1: [],
      // pointData: [],
      BMap: '',
    }
  },
  mounted() {
    this.$nextTick(() => { // 页面渲染完成后的回调
      this.conHeight.height = this.$refs.container.offsetHeight - 90 + 'px'
    })
    this.getGeoJson(100000);
    this.init();
    var that=this;
    window.addEventListener("resize", () => {
        that.myChart.resize();
    });
  },
  components: {},
  watch: {
    //监听全局变量
    '$store.state.tableHeight': function () {
      this.conHeight.height = this.$refs.container.offsetHeight - 90 + 'px'
    },
  },
  // created(){
  //    this.init()
  // },
  methods: {
    currentChange(val){
      this.dataInfo2.forEach(ele=>{
        if(val.lat == ele.lat && val.lon == ele.lon){
          ele.fangdabeishu = 15;
        }else {
          ele.fangdabeishu = 7;
        }
      });
      this.getMapData();
      /*let index = this.dataInfo2.indexOf(val);
      this.dataInfo2.splice(index,1);
      this.dataInfo2.push(val2);
      this.getMapData();*/
    },
    init() {
      // 获取要展示的相关的数据：
      this.getAxios("Visual/GetListLonNotNull");
    },
    getAxios(url){
      return new Promise((resolve, reject) => {
        this.$axios({
          method: 'post',
          url: this.$institutionUrl + url,
          data: {
            timeStr:timeStr,
            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
            governmentCodeList:JSON.parse(getToken()).visualAccountInsGovernmentCodeList
          }
        }).then( (response)=> {
          if(response.data.error == 0){
            this.tableData1 = response.data.data;
            // eslint-disable-next-line no-debugger
            // debugger
            this.dataInfo2 = response.data.data;
            this.dataInfo2.map(ele=>{
              ele.fangdabeishu = 7;
            })

            // 根据经纬度获取 “城市名”，并将其点亮
            this.dianliangCity(this.tableData1);
            resolve(response.data.data);
          }else if(response.data.error == 1){
            this.$message({type: 'info', message: response.data.message});
          }
        }).catch(function (error) {
          reject(error.data)
        });
      });
    },
    handler({ BMap }) {
      this.BMap=BMap
    },
    dianliangCity(tableData){
      var _this = this;
      tableData.map(item => {
        // 根据经纬度获取省市区   lon:经度     lat纬度
        /*console.log("根据经纬度获取省市区   lon:经度     lat纬度");
        console.log(item);*/
        var lon = item.lon;
        var lat = item.lat;
        var myGeo = new this.BMap.Geocoder();
        console.log(myGeo);
        var pt = new this.BMap.Point(lon,lat);
        console.log(pt);

        /*myGeo.getLocation(pt,function(result){
          /!*console.log("83uqoigldskavk;dlsvndfsnv;ldkmvkfdsnlk;vlda;'vnkajvh'JW;LV;DLKNVDJKLVNDSALN.V.DSVKJLSANnvkdlsnvlkad")
          console.log(result);
          console.log(result.addressComponents.province);*!/
          if(_this.Citys){
            _this.Citys.push(result.addressComponents.province);
            _this.Citys.push(result.addressComponents.city);
            _this.Citys.push(result.addressComponents.district);
          }
          _this.getMapData();
        });*/
        _this.getMapData();
      })
    },

    // 得到所有的省和相应的code
    getGeoJson(adcode) {
        let that = this;
        this.$AMapUI.loadUI(["geo/DistrictExplorer"], DistrictExplorer => {
          var districtExplorer = new DistrictExplorer();
          districtExplorer.loadAreaNode(adcode, function (error, areaNode) {
            if (error) {
            //   console.error(error);
              return;
            }
            let Json = areaNode.getSubFeatures();
            if (Json.length > 0) {
              that.geoJson.features = Json;
            } else if (Json.length === 0) {
              that.geoJson.features = that.geoJson.features.filter(
                item => item.properties.adcode == adcode
              );
              if (that.geoJson.features.length === 0) return;
            }
            that.getMapData();
          });
        });
      },
      //获取数据
      getMapData() {
        let mapData =[];
        let pointData =[];
        this.geoJson.features.map(item => {
          // let list = ['安徽省','合肥市','蜀山区','湖南省','衡阳市','雁峰区'];
          // let value =this.Citys.indexOf(item.properties.name)==-1?0:Math.random() * 40;
          // 将所有省份的信息封装到mapData集合中，并对其进行排序
          mapData.push({
              name: item.properties.name,
              value: Math.random() * 40,
              cityCode: item.properties.adcode
          })
          // 将所有省份的信息和经纬度封装到 pointData 集合中
          /*pointData.push({
              name: item.properties.name,
              value: [item.properties.center[0], item.properties.center[1],value],
              cityCode: item.properties.adcode
          })*/
        });
        // 将要点亮的经纬度封装到 pointData 数组中
        this.dataInfo2.map( element =>{
          let ele = {
            name: element.name,
            value:[element.lon,element.lat,element.fangdabeishu]
          };
          pointData.push(ele);
        })


        mapData = mapData.sort(function (a, b) {
          return a.value[2] - b.value[2];
        });
        this.initEcharts(mapData,pointData);
      },
      initEcharts(mapData,pointData) {
        this.myChart = this.$echarts.init(this.$refs.sctterMap);
        if (this.parentInfo.length === 1) {
             this.$echarts.registerMap('china', this.geoJson); //注册
        } else {
             this.$echarts.registerMap('map', this.geoJson); //注册
        }
        var min = mapData[mapData.length - 1].value
        var max = mapData[0].value
        if (mapData.length === 1) {
            min = 0
        }
        this.myChart.clear();
        this.myChart.setOption({
            tooltip: {
              trigger: "item",
              formatter: p => {
                /*let val = p.value[2];
                if (window.isNaN(val)) {
                  val = 0
                }
                let txtCon = p.name + ":" + "<br>" +     val.toFixed(2);
                return txtCon;*/
                /*let i1 = p.value[0];
                let i2 = p.value[1];*/
                let txtCon = p.name + ":<br>" +  '经度' + p.value[0] + '  维度：' + p.value[1];
                return txtCon;
              }
            },
            title: {
              show: true,
              left: "center",
              top: "15",
              text: this.parentInfo[this.parentInfo.length - 1].cityName +
                "地图",
              textStyle: {
                color: "rgb(179, 239, 255)",
                fontSize: 16
              }
            },
            grid: {
                right: '2%',
            },
            animation: true,
            animationDuration: 900,
            animationEasing: 'cubicInOut',
            animationDurationUpdate: 900,
            animationEasingUpdate: 'cubicInOut',

            geo:{
              name: "地图",
              type: "map",
              map: this.parentInfo.length === 1 ? 'china' : 'map',
              roam: true, //是否可缩放
              data: mapData,
              layoutCenter: this.parentInfo.length === 1 ? ['30%', '68%'] : ['33%', '50%'],
              layoutSize: this.parentInfo.length === 1 ?1000:800,
              label: {
                normal: {
                  show: true,
                  color: "rgb(249, 249, 249)", //省份标签字体颜色
                  formatter: p => {
                    switch (p.name) {
                      case "内蒙古自治区":
                        p.name = "内蒙古";
                        break;
                      case "西藏自治区":
                        p.name = "西藏";
                        break;
                      case "新疆维吾尔自治区":
                        p.name = "新疆";
                        break;
                      case "宁夏回族自治区":
                        p.name = "宁夏";
                        break;
                      case "广西壮族自治区":
                        p.name = "广西";
                        break;
                      case "香港特别行政区":
                        p.name = "香港";
                        break;
                      case "澳门特别行政区":
                        p.name = "澳门";
                        break;
                      default:
                        break;
                    }
                    return p.name;
                  }
                },
                emphasis: {
                  show: true,
                  color: "#f75a00"
                }
              },
              itemStyle: {
                normal: {
                  areaColor: "transparent",
                  borderColor: "#53D9FF",
                  borderWidth: 1.3,
                  shadowBlur: 15,
                  shadowColor: "rgb(58,115,192)",
                  shadowOffsetX: 7,
                  shadowOffsetY: 6
                },
                emphasis: {
                  areaColor: "#8dd7fc",
                  borderWidth: 1.6,
                  shadowBlur: 25
                }
              }
            },
            visualMap: {
                min: min,
                max: max,
                left: '3%',
                show:false,
                bottom: '5%',
                calculable: true,
                seriesIndex: [0],
                inRange: {
                    color: ['#24CFF4', '#2E98CA', '#1E62AC']
                },
                textStyle: {
                    color: '#24CFF4'
                }
            },
            series: [{
                    name:'销售额度',
                    type: 'map',
                    geoIndex: 0,
                    map: this.parentInfo.length === 1 ? 'china' : 'map',
                    roam: true,
                    zoom: 1.3,
                    tooltip: {
                        trigger: "item",
                        show:false,
                    },
                    label: {
                        normal: {
                            show: false,
                        },
                        emphasis: {
                            show: false,
                        }
                    },
                    data: mapData,

                }, {
                    name: '散点',
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    rippleEffect: {
                        brushType: 'fill',
                        scale: 5
                    },
                    itemStyle: {
                        normal: {
                            // color: '#F4E925',
                            color: function(e){
                              if(e.value[2] == 15){
                                return '#f50707';
                              }
                              return '#F4E925'
                            },
                            shadowBlur: 10,
                            shadowColor: '#333'
                        }
                    },
                    data: pointData,   // data中数据为要点亮的点，data[{},{},{}]
                    symbolSize: function (val) {
                        let value = val[2]
                        if (value == 0) {
                            return 0
                        }
                        return value;
                    },
                    showEffectOn: 'render', //加载完毕显示特效
                },
            ]
          },
          true
        );
        let that = this;
        this.myChart.off("click");
        this.myChart.on("click", params => {
          let flag = false;
          pointData.forEach(ele => {
            if(ele.value[0] == params.data.value[0] && ele.value[1] == params.data.value[1]){
              flag = true;
              return true;
            }
          });

          if(!flag){
            if (!params.data) {
              this.dialogTableVisible=true;
              return;
            }
            /*if (that.parentInfo[that.parentInfo.length - 1].code == params.data.cityCode) {
              this.dialogTableVisible=true
              return;
            }*/
            let data = params.data;
            that.parentInfo.push({
              cityName: data.name,
              code: data.cityCode
            });
            that.getGeoJson(data.cityCode);
          }else{
            this.dataInfo2.map(ele => {
              if(ele.lon == params.data.value[0] && ele.lat == params.data.value[1]){
                this.dialogData = ele;
                this.dialogTableVisible=true;
                return;
              }
            })
          }
        });
      },


      //选择切换市县
      chooseArea(val, index) {
        if (this.parentInfo.length === index + 1) {
          return
        }
        this.parentInfo.splice(index + 1);
        this.getGeoJson(this.parentInfo[this.parentInfo.length - 1].code);
        // this.dialogTableVisible = true;
      }
  }
}


</script>

<style lang="scss" scoped>
.header{
    position: relative;
    width: 100%;
    min-width: 1360px;
    height: 75px;
    z-index:0;
    .topImg{
        width: 100%;
        position: absolute;
        height: 111px;
    }
    .titles{
        width: 500px;
        margin: 0 auto;
        position: relative;
        color: #fff;
        text-align: center;
        line-height: 75px;
        font-weight: bold;
        font-size: 45px;
        text-shadow:5px 2px 6px #000;
    }
    .topTime{
        float: left;
        margin-left: 55px;
        margin-top: 5px;
        position: relative;
        color: #2FBFFA;
        background: rgba($color: #000000, $alpha: 0.4);
        padding: 1px 20px;
        font-size: 14px;
        height: 25px;
        border-radius: 20px;
        img{
            height: 20px;
            width: 20px;
            transform: translate(0,4px);
        }
    }
    .out{
        float: right;
        margin-right: 55px;
        margin-top: 3px;
        font-size: 20px;
        position: relative;
        color: #2FBFFA;
        padding: 1px 20px;
        height: 25px;
        border-radius: 20px;
    }
}
.mapDialog{
  .modal{
      // height: 510px;
      // box-shadow: inset 0px -11px 11px #083280;
      // box-sizing: border-box;
      // border: 1.5px solid #044f71;
      // border-top: 0;
      // background: RGBA(1, 16, 56, 0.8);
      position: relative;
      .backgroundImg{
        height: 330px;
        width: 100%;
        top: -30px;
        // left: -20px;
        position: absolute;
      }
      .cont{
        // width: 100%;
        height: 100%;
        position: relative;
        padding: 20px;
        .head{
          color: rgba(0, 204, 255, 1);
          font-size: 20px;
          line-height: 40px;
          margin-bottom:40px;
          width: 100%;
          display: flex;
          align-items: center;
          img{
            float: left;
            height: 90px;
            width: 90px;
            margin-right: 20px;
          }
        }
      }
    }
    /deep/ .el-dialog{
      background: transparent;
      box-shadow: none;
    }
}
.map-container {
    width: 100%;
    height: 100vh;
    margin-top: -75px;
    background-image: url(mapImg/back.png);
    // background-image: url(./img/back.jpg);
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center top;
    min-width: 1360px;
    min-height: 736px;

    ::-webkit-input-placeholder { /* WebKit browsers */
        color: rgba(0, 236, 252, 1);
    }

    ::-moz-placeholder { /* Mozilla Firefox 19+ */
        color: rgba(0, 236, 252, 1);
    }

    :-ms-input-placeholder { /* Internet Explorer 10+ */
        color: rgba(0, 236, 252, 1);
    }
    .content {
        height: 100%;
        margin: 0;
        padding: 0;
        // margin-top: 80px;
        // padding: 0 2.6vw;
        padding-top: 90px;
    }
    .contentsTable{
      position: absolute;
      right: 5vw;
      height: 80vh;
      width: 500px;
      top: 100px;
      // .table{
      //   background: ;
      // }
      .leftBox{
        height: 85vh;
        min-height: 625px;
        width: 100%;
        position: relative;
        img{
          position: absolute;
          width: 100%;
          height: 100%;
        }
        .leftBoxInfo{
          width: 100%;
          position: relative;
          padding-top: 5vh;
          .title{
            width: 100%;
            text-align: center;
            font-size:28px;
            font-weight:400;
            color:rgba(0,236,252,1);
            line-height:49px;
            img{
              width: 90%;
              height: 18px;
              margin-left: 6%;
              margin-top:5px;
              display: block;
              transform: translate(0,-10px);
            }
          }

        }
      }
    }
    .contents {
        min-width: 1220px;
        height: 100%;
        .centered{
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .mapChoose {
            position: absolute;
            left: 20px;
            top: 55px;
            color: #eee;


            .title {
            padding: 5px;
            border-top: 1px solid rgba(147, 235, 248, .8);
            border-bottom: 1px solid rgba(147, 235, 248, .8);
            cursor: pointer;
            }

            .icon {
            font-family: "simsun";
            font-size: 25px;
            margin: 0 11px;
            }
        }
    }
    /deep/ .el-table {
        background-color:transparent;
    }
    .el-table::before {
        height: 0px;
    }
    /deep/ .el-table th {
        background-color:rgba(17, 55, 107, 1);
    }
    /deep/ .el-table__row td{
        border: none;
    }
    /deep/ .el-table__header tr {
        // background-image: linear-gradient(to right,rgba(1, 125, 252, 1),rgba(5, 140, 255, 0.01));
        background-color: rgba(17, 55, 107, 1);
    }
        /deep/ .el-table__body .el-table__row{
            background-color: transparent;
    }
        /deep/ .el-table__body .el-table__row--striped td{
            background-color:rgba(13, 57, 117, 0.5);
    }
    /deep/ .el-table th.is-leaf {
        border: 0;
    }
    /deep/ .el-table__header .cell {
        color: rgba(28, 252, 255, 1);
    }
    /deep/ .el-table td div {
        color: rgba(161, 212, 255, 1);
    }
    /deep/  .el-table__body{
        width: 100% !important;
    }
    /deep/ .el-table__header .gutter{
        display: none !important;
    }
    /deep/ .el-table tbody tr:hover>td {
        background-color:transparent!important
    }
    /deep/  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {width: 17px;}
    /deep/  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
        border-radius: 10px;
        display: none;
        background: #00FFFF;
    }
    /deep/ .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
        border-radius: 0;
        background: transparent;
    }
    /*/deep/ .el-table--striped .el-table__body tr.el-table__row--striped.current-row td, .el-table__body tr.current-row>td {
      color: #147edb;
      background-color: #F30606FF !important;
    }*/
}

</style>
